import { useState } from 'react';

import Popup from '@/components/Popup/PopUp/PopUp';
import Button from '@/components/shared/Button/Button';
import { Select } from '@/components/shared/Select/Select';
import { Text } from '@/components/shared/Text/Text';
import { CanceledBy } from '@/lib/types';

interface ConfirmCancelModalProps {
  isPopupOpen: boolean;
  closePopup: () => void;
  handleConfirm: (cancelingBy: CanceledBy) => void;
}

const options = [
  { value: 'coach', label: 'Coach' },
  { value: 'user', label: 'User' },
];

const ConfirmCancelModal = ({
  isPopupOpen,
  closePopup,
  handleConfirm,
}: ConfirmCancelModalProps) => {
  const [selectedBy, setSelectedBy] = useState<string | null>('coach');

  const handleSelectChange = (value: string | null) => {
    setSelectedBy(value);
  };

  return (
    <Popup variant={'danger'} isOpen={isPopupOpen} handleClose={closePopup}>
      <div className="flex gap-4 h-full">
        <img
          className="rounded-lg bg-danger-50 w-12 h-12 p-2"
          src={'/icons/ban.svg'}
          alt={'close'}
        />

        <div>
          <Text.Big weight="bold" className="text-danger-60">
            Cancel Session Now
          </Text.Big>
          <Text.Regular className="text-danger-60 mb-4">
            {
              'Are you sure you want to cancel\nthe session?\n\nThe session will be canceled immediately.'
            }
          </Text.Regular>
          <div className="w-full mb-4 flex items-center gap-4">
            <Text.Regular className="text-danger-60">Canceled by:</Text.Regular>
            <Select
              value={selectedBy}
              className="w-full border-danger-50 bg-danger-60 text-md text-white-100 !font-semibold"
              onChange={handleSelectChange}
              options={options}
            />
          </div>
          <Button
            prefixIcon={<img src={'/icons/check.svg'} />}
            label="Yes, Cancel"
            size="s"
            className="!w-40 !bg-danger-60 mr-4 hover:!bg-danger-40"
            onClick={() => handleConfirm(selectedBy as CanceledBy)}
          />
          <Button
            prefixIcon={<img src={'/icons/ban_red.svg'} />}
            label="No"
            variant="transparent"
            onClick={closePopup}
            className="!w-20 border !border-danger-60 hover:border-danger-40 text-danger-50"
            size="s"
          />
        </div>
      </div>
    </Popup>
  );
};

export default ConfirmCancelModal;
